export default __webpack_public_path__ + "static/media/dinner.6c845577.png";